// extracted by mini-css-extract-plugin
export default {"eventContainer":"event_eventContainer__BoZK0","event":"event_event__UWy6J","eventName":"event_eventName__6Pv+p"};